import * as React from 'react';

const SvgUniqueErgo2Light = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 148 151"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M73.838 150c40.228 0 72.838-32.583 72.838-72.777 0-40.193-32.61-72.777-72.838-72.777C33.611 4.446 1 37.03 1 77.223 1 117.417 33.61 150 73.838 150Z"
      stroke="#121212"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.84 120.081c23.691 0 42.896-19.189 42.896-42.86 0-23.67-19.205-42.859-42.895-42.859-23.69 0-42.896 19.19-42.896 42.86 0 23.67 19.205 42.859 42.896 42.859Z"
      stroke="#121212"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.121 38.242a39.519 39.519 0 0 1 29.276 7.467 39.435 39.435 0 0 1 15.421 25.955 39.408 39.408 0 0 1-7.475 29.243 39.493 39.493 0 0 1-41.363 14.582 39.479 39.479 0 0 1-13.894-6.64 39.43 39.43 0 0 1-10.29-11.448A39.384 39.384 0 0 1 34.68 82.89a39.44 39.44 0 0 1 7.478-29.232 39.525 39.525 0 0 1 25.964-15.416Z"
      fill="url(#unique-ergo-2-light_svg__a)"
    />
    <path
      d="M73.84 124.475c2.457 0 4.45-1.99 4.45-4.446a4.447 4.447 0 0 0-4.45-4.445 4.447 4.447 0 0 0-4.45 4.445 4.447 4.447 0 0 0 4.45 4.446Z"
      fill="#FF5E18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.694 28.179a1.327 1.327 0 0 1-.789-1.793 1.326 1.326 0 0 1 1.794-.789 55.299 55.299 0 0 1 25.78 20.31 55.173 55.173 0 0 1 9.616 31.37 55.082 55.082 0 0 1-9.687 31.189 55.238 55.238 0 0 1-25.78 20.328 1.343 1.343 0 0 1-1.068-.007 1.353 1.353 0 0 1-.727-.782 1.379 1.379 0 0 1 .79-1.793 52.501 52.501 0 0 0 24.488-19.323 51.95 51.95 0 0 0 9.275-29.613 52.05 52.05 0 0 0-9.203-29.702 52.773 52.773 0 0 0-24.489-19.395ZM55.02 126.212a1.387 1.387 0 0 1 .885 1.261c.004.182-.029.362-.095.532a1.366 1.366 0 0 1-1.794.789 55.231 55.231 0 0 1-25.78-20.328 54.961 54.961 0 0 1-9.617-31.19 55.052 55.052 0 0 1 9.706-31.244 55.303 55.303 0 0 1 25.78-20.31 1.346 1.346 0 0 1 1.794.79 1.325 1.325 0 0 1-.789 1.792A52.773 52.773 0 0 0 30.55 47.52a51.953 51.953 0 0 0-9.204 29.756 51.74 51.74 0 0 0 9.204 29.667 52.503 52.503 0 0 0 24.488 19.269h-.018Z"
      fill="url(#unique-ergo-2-light_svg__b)"
    />
    <path
      d="M95.8 15.523a7.764 7.764 0 0 0 7.768-7.761A7.764 7.764 0 0 0 95.8 0c-4.29 0-7.768 3.475-7.768 7.762 0 4.286 3.478 7.761 7.768 7.761ZM20.056 137.094c5.985 0 10.836-4.847 10.836-10.827 0-5.979-4.851-10.827-10.836-10.827-5.984 0-10.836 4.848-10.836 10.827 0 5.98 4.852 10.827 10.836 10.827Z"
      fill="#FF5E18"
    />
    <defs>
      <radialGradient
        id="unique-ergo-2-light_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 39.4357 -39.469 0 73.75 77.278)"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={0.557} stopColor="#FF5E18" stopOpacity={0.589} />
        <stop offset={1} stopColor="#FF5E18" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="unique-ergo-2-light_svg__b"
        x1={58.501}
        y1={80.862}
        x2={57.605}
        y2={25.294}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={0.34} stopColor="#FF5E18" stopOpacity={0.46} />
        <stop offset={1} stopColor="#FF5E18" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgUniqueErgo2Light;
